"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/UGFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_238)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_238`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6.00171 0H30.0018V24H-6.00171V0Z",
					fill: "#232323"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6.00171 4.00122H30.0018V8.00239H-6.00171V4.00122Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6.00171 8.00232H30.0018V12.0035H-6.00171V8.00232Z",
					fill: "#D32300"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6.00171 16.0046H30.0018V20.0058H-6.00171V16.0046Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6.00171 19.9988H30.0018V24H-6.00171V19.9988Z",
					fill: "#D32300"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.0001 17.6783C15.1342 17.6783 17.6749 15.1376 17.6749 12.0035C17.6749 8.86942 15.1342 6.32874 12.0001 6.32874C8.866 6.32874 6.32532 8.86942 6.32532 12.0035C6.32532 15.1376 8.866 17.6783 12.0001 17.6783Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.4882 8.9657C10.5515 8.86725 9.10992 8.82506 9.10992 8.82506C9.22946 8.64926 10.4038 8.08671 10.4038 8.08671C10.4038 8.08671 10.3405 7.66479 10.5937 7.39758L10.2772 6.70845C10.2772 6.70845 10.7695 6.46936 11.5711 6.46936C12.3727 6.46936 12.9704 6.9616 13.0478 7.39054L12.5978 7.62963C12.5907 7.96013 12.7173 8.44533 12.2954 8.84616C11.8805 9.24698 11.7117 9.33136 11.6977 10.1682C11.6977 10.4424 11.8594 10.7448 12.3165 10.9909C13.54 11.6449 15.0308 12.9739 15.4527 13.3747C15.8817 13.7755 15.8114 14.7249 15.6356 15.1468C15.4598 15.5687 14.7847 16.1523 14.63 16.1031C14.4753 16.0609 14.7144 15.4562 14.3839 15.2874C14.3839 15.2874 13.758 14.753 13.2025 15.3296C12.647 15.9062 13.1884 17.1016 13.4767 17.2985C13.7651 17.4954 13.5963 17.6501 13.3431 17.6501H11.3672C11.1 17.6501 10.9874 17.4884 11.2336 17.2985C11.768 17.0313 12.1055 16.2227 11.7539 15.8711C11.4094 15.5265 10.4671 15.9765 10.2421 16.3141C10.0452 16.511 9.62325 16.5672 9.33494 16.2156C9.04663 15.864 9.04663 15.4843 9.25759 15.3366C9.74982 14.9991 9.25759 15.3366 9.26462 15.3296C9.26462 15.3296 10.1014 14.7249 11.3672 14.6967C11.6414 14.6967 11.7047 14.542 11.5219 14.3592C11.5219 14.3592 9.349 12.4324 9.5459 11.2511C9.75686 9.96423 10.9523 9.40168 10.4882 8.9657Z",
					fill: "black"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_238`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as UGFlag };
